module.exports = __webpack_public_path__ + "static/media/6.b0c4cc76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magazine/6.jpg
// module id = 59
// module chunks = 0